import React from 'react';
import { CandidatesList } from './candidates-list';
import { setBreadcrumbs } from 'works/legacy/lib/client-store';
import { AppContent } from '@common/components';

export function ApplicationsPage() {
  setBreadcrumbs([{ name: 'Applications', path: '/works/candidates' }]);
  return (
    <AppContent top={false}>
      <CandidatesList />
    </AppContent>
  );
}
